import { Banner } from 'Components/shared/Banner';
import { MobXProviderContext, observer } from 'mobx-react';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { RootStoreProps } from 'Stores/RootStore.types';
import { pushToGTMDataLayer } from 'Utils/analytics';
import { getBannerVariantProps } from '../helpers/getBannerVariantProps';
import { BannerLayoutProps } from '../index.types';
import { DesktopNotificationsBannerWrapperProps } from './index.types';

export const DesktopNotificationsBannerWrapper = observer(
  ({
    action,
    onClose,
    variant,
  }: DesktopNotificationsBannerWrapperProps & BannerLayoutProps) => {
    const { notification: notificationStore } =
      React.useContext<RootStoreProps>(MobXProviderContext);

    const navigate = useNavigate();

    const handleOpenSettings = useCallback(() => {
      pushToGTMDataLayer('notifications_banner_open_settings');

      void navigate('/settings/notifications');
    }, [navigate]);

    const handlEnableNotifications = useCallback(() => {
      notificationStore.setWebNotificationPromptActionTaken(true);

      const wasEnabled = notificationStore.tryEnableWebNotifications();

      wasEnabled && pushToGTMDataLayer('notifications_banner_enable');
    }, [notificationStore]);

    return (
      <>
        <Banner
          isFullWidth
          type={'info'}
          id="desktop-notification-banner-wrapper"
          message={
            'Don’t miss out! Enable desktop notifications to stay on track of everything.'
          }
          showCloseButton={false}
          {...getBannerVariantProps(variant)}
          action={[
            {
              label: 'Dismiss',
              onClick: onClose,
            },
            action === 'open_settings'
              ? {
                  label: 'Open settings',
                  onClick: handleOpenSettings,
                }
              : {
                  label: 'Enable',
                  onClick: handlEnableNotifications,
                },
          ]}
        />
      </>
    );
  }
);
